
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-to-heic-converter",
      function () {
        return require("private-next-pages/image-to-heic-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-to-heic-converter"])
      });
    }
  